import React, { Component } from 'react';
import { connect } from 'react-redux';
import {TextField, MenuItem,Select, InputLabel, FormControl, ListItemText, Checkbox} from '@material-ui/core';
import { isEmpty,isUndefined } from 'lodash';
import CheckIcon from '@material-ui/icons/Check';
import Chip from '@material-ui/core/Chip';
import Grid from '@material-ui/core/Grid';
import IntlMessages from 'util/IntlMessages';

function mapStateToProps({auth, Ärende, accountsData}) {
  const { authUser } = auth;
  const { flode } = Ärende
  const { medarbetare } = Ärende
  const { AllChildKontoUsers, Flags } = accountsData;
  return {
    authUser, flode, AllChildKontoUsers, medarbetare, Flags
  };
}

function mapDispatchToProps(dispatch) {
  return {
      
      dispatch
  };
}

class SelectMultiMedArbetare extends Component {
    
    state = {
      users: []
    }
    
    componentDidMount() {
      try {
        let users = JSON.parse(this.props.usersJSON)
        this.setState({users: users})
      } catch (err) { }
    }

    onChangeHandle=(e)=>{
    
      try {
        const {
          target: { value },
        } = e;
        // let users = JSON.parse(this.props.usersJSON)
        if(isUndefined(value.find(v => v === -1))) {
          console.log(value)
          // if(isUndefined(users.find(t => t === parseInt(e.target.value)))) users.push(parseInt(e.target.value))
          this.props.setUsersJSON(JSON.stringify(typeof value === 'string' ? value.split(',') : value))
          this.setState({users: typeof value === 'string' ? value.split(',') : value})
        }
      } catch (err) {}
    }
    handleChipDelete=(id)=>{
      try {
        let users = JSON.parse(this.props.usersJSON)
        users = users.filter(t => t !== id)
        this.props.setUsersJSON(JSON.stringify(users))
        this.setState({users: users})
      } catch (err) {}
    }
    returnUsers = () => {
      try {
        let taggar = JSON.parse(this.props.usersJSON)
        return taggar
      } catch (err) { return []}
    }

    handleSelectKonto=(e, konto)=> {
      let ursersArr = [...this.state.users, ...konto.map(k => k.UserID)]

      ursersArr = [...new Set(ursersArr.map(u => u))]

      this.props.setUsersJSON(JSON.stringify(ursersArr))
      this.setState({users: ursersArr})
    }

    render() {
        return (
            <>
                <Grid item xs={12}>
                <FormControl variant='outlined' fullWidth size='small'>
                  <InputLabel id="demo-simple-select-label"><IntlMessages id="appKontoModule.Coworker"/></InputLabel>
                  <Select
                    multiple
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label={<IntlMessages id="appKontoModule.Coworker"/>}
                    value={this.state.users}
                    onChange={this.onChangeHandle}
                    renderValue={(selected) => ''}
                  >
                    {
                     !isEmpty([...new Set( this.props.AllChildKontoUsers.filter(u => parseInt(u.CanSeeDashboardPlus) === 1).map(item => item.Afid))])?
                     [...new Set( this.props.AllChildKontoUsers.filter(u => parseInt(u.CanSeeDashboardPlus) === 1).map(item => item.Afid))].map(
                      (k,i) => {
                        let konto = this.props.AllChildKontoUsers.filter(u => parseInt(u.CanSeeDashboardPlus) === 1)
                          .filter(item=>{return !isEmpty(item.UserEmail)})
                          .filter(_k => _k.Afid === k)
                        if(isUndefined(konto[0])) return ''
                        return (
                          <MenuItem key={konto.map(k => k.UserID).join('')} value={-1} onClick={(e) => this.handleSelectKonto(e,konto)}>
                            {konto[0].KontoName}
                          </MenuItem>
                        )
                      }
                     ) 
                     : 
                     ''
                    }
                    {            
                    !isEmpty(this.props.AllChildKontoUsers.filter(u => parseInt(u.CanSeeDashboardPlus) === 1))?
                    this.props.AllChildKontoUsers.filter(u => parseInt(u.CanSeeDashboardPlus) === 1)
                      .filter(item=>{return !isEmpty(item.UserEmail)})
                      .map((option) => {

                      
                      if(this.state.users.indexOf(option.UserID) > -1) {
                        return (
                          <MenuItem key={option.UserID} value={option.UserID}>
                            <div className="d-flex align-items-center justify-content-between w-100">
                              {
                                parseInt(this.props.Flags.IsHuvudKonto) === 1 ?
                                (option.KontoName+" - "+option.FirstName + " " +option.LastName) :
                                (option.FirstName+" "+option.LastName)
                              } 
                              <CheckIcon style={{fontSize: 14, marginLeft: 10}}/>
                            </div>
                          </MenuItem>
                        )
                      }
                      return(
                        <MenuItem key={option.UserID} value={option.UserID}>
                          {
                            parseInt(this.props.Flags.IsHuvudKonto) === 1 ?
                            (option.KontoName+" - "+option.FirstName + " " +option.LastName) :
                            (option.FirstName+" "+option.LastName)
                          } 
                        </MenuItem>
                      )
                    }):""}
                  </Select>
                </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                    <div className="my-2">
                    {!isEmpty(this.returnUsers())?
                    this.returnUsers().map((n)=>{
                      //  let id =isUndefined(n.MUserid)?n:n.MUserid
                      let filA = this.props.AllChildKontoUsers.filter((m)=>{
                            if(parseInt(m.UserID) === parseInt(n)){
                                return m
                            }
                        })
                        if(isEmpty(filA)) return ''
                        return <>
                        <Chip 
                          label={`${filA[0].FirstName} ${filA[0].LastName}`} 
                          color="primary"
                          size="small"
                          className="ml-1 mb-1"
                          onDelete={()=>this.handleChipDelete(n)}
                        />
                        </>                   
                        
                    })
                    :""}
                </div> 
                </Grid>
            
            </>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SelectMultiMedArbetare);